import React, { useEffect } from 'react';
import Main from './components/main/main.jsx';
import Cookies from 'js-cookie';
import { sanitize } from './utils/sanitize.js';
import { ISearchParams, getParams } from './url.js';
import { Auth0Provider } from '@auth0/auth0-react';
import { environment } from './config/environment.ts';


interface MyProps {}

const Root: React.FC<MyProps> = () => {
  const searchParams: ISearchParams = getParams(location.search);

  const setCookieAndNormalizeData = () => {
    const queryCampaign = JSON.parse(sanitize(JSON.stringify(searchParams)));

    queryCampaign.sid = Cookies.get('TBD');

  };

  useEffect(() => {
    setCookieAndNormalizeData();
  }, []);
  console.log("environment:", environment);
  return (
    <Auth0Provider
      domain={environment?.auth0?.domain}
      clientId={environment?.auth0?.clientId}
      authorizationParams={{
        redirect_uri: environment?.auth0?.redirect_uri,
        scope: environment?.auth0?.authorizationParams.scope,
      }}
    >
      <Main />
    </Auth0Provider>
  );
};

export default Root;
